const DefaultFieldTypeMap = {
  TextField: 'string',
  RichTextField: 'markdown',
  NumberField: 'numeric',
  TimelineField: 'timeline',
  PhotoField: 'photo',
  SingleSelectField: 'single-select',
  MultiSelectField: 'multi-select',
}
export default DefaultFieldTypeMap
